export default {
      id: "weekview-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#weekview",
      toString: function () {
        return this.url;
      }
    }